import { useEffect, useState } from 'react';
import jwtDecode from 'jwt-decode';
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';

import Announcement from '../components/Announcement';
import Footer from '../components/Footer';
import Mitra from '../components/Mitra';
import Navbar from '../components/Navbar';
// import Products from '../components/Products';
import Slider from '../components/Slider';
import BlogsComponent from '../components/Blogs';

import {
  Button,
  Grid
} from "@mui/material";

const verifyToken = (serviceToken) => {
  if (!serviceToken) {
    return false;
  }
  const decoded = jwtDecode(serviceToken);
  /**
   * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
   */
  return decoded.exp > Date.now() / 1000;
};

const Home = (Props) => {
  const navigate = useNavigate();
  const [blogData, setBlogData] = useState([]);
  const [token, setToken] = useState(
    JSON.parse(localStorage.getItem('token')) !== null ?
      JSON.parse(localStorage.getItem('token')).token :
      null
  );

  useEffect(() => {
    if (verifyToken(token)) {
      navigate('/dashboard');
    }
    const getBlogs = async () => {
      try {
        const blogData = await axios.get(`${process.env.REACT_APP_API_URL}/api/blogs`, {
          params: {
            limit: 4
            // page: page.value,
            // perPage: pageSize.value
          }
        });
        console.log(blogData.data.result);
        setBlogData(blogData.data.result.data);
      } catch (err) {
        console.log(err);
      }
    };
    getBlogs();
  }, []);

  return (
    <div>
      <Navbar Cart={Props.Cart} />
      <Slider />
      {/* blog temporary disabled */}
      {/* <BlogsComponent
        blogData={blogData}
      />
      <Grid item xs={12} sx={{ paddingY: '20px' }} display="flex" alignItems="center" justifyContent="center">
        <Button variant="outlined" onClick={() => navigate('/blogs')} size="large">View All</Button>
      </Grid> */}
      <Mitra />
      <Footer />
    </div>
  )
}

export default Home
